import {ToastrService} from 'ngx-toastr';
import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AccessControlService} from 'src/app/services/access-control.service';
import {AlertService} from 'src/app/services/alert.service';
import {Router, ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

// declare var $: any
@Component({
  selector: 'app-add-application',
  templateUrl: './add-application.component.html',
  styleUrls: ['./add-application.component.css'],
  // encapsulation: ViewEncapsulation.None
})
export class AddApplicationComponent implements OnInit {
  @ViewChild('addapplicationForm') public addapplicationForm: NgForm
  model: any = {};
  id: any;
  opt: any;
  buttonTitle: String = '';
  title: String = '';
  isExtensionError: boolean = false;
  isLogoSizeError: boolean = false;
  logo: any;
  username: string;
  org_id: any;
  isLoading: boolean;
  isSavingData = false;

  constructor(private accesscontrolService: AccessControlService,
              private toastservice: ToastrService,
              private alertService: AlertService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.opt = this.activatedRoute.snapshot.queryParamMap.get('opt')
  }

  ngOnInit() {
    this.org_id = localStorage.getItem('user_id');
    this.username = localStorage.getItem('username')
    if (this.opt == 'add') {
      this.buttonTitle = 'Save'
      this.title = 'Add Application'
      this.model.jwt_expiration = 3
      this.model.application_name = "New Application Name"
    } else {
      this.buttonTitle = 'Update'
      this.title = 'Edit Application'
      // this.getapplicationbyId();
      this.getOrganizationApplicationDetails()
    }


  }

  submit() {
    if (!this.addapplicationForm.valid) {
      return
    }
    this.isSavingData = true
    if (this.opt == 'add') {
      this.addApplication();
    } else {
      this.updateApplication();
    }
  }

  //add System Module
  addApplication() {
    if (this.username + "" != "admin@gsf.com") {
      this.model.org_id = this.org_id
    }
    this.model.value = false
    this.model.created_by = this.username;
    debugger
    this.accesscontrolService.addApplication(this.model).subscribe((res) => {

    }, error => {
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastservice.error(errorMessage)
    }, () => {
      this.toastservice.success("Application Added Successfully");
      this.router.navigate(['/application-listing'])
    })
  }

  getapplicationbyId() {
    this.accesscontrolService.getapplicationbyId(this.id).subscribe((res) => {
        this.model = res;
      }, error => {
        console.log(error)
      },
      () => {

      })
  }

  updateApplication() {
    if (this.username + "" != "admin@gsf.com") {
      this.model.org_id = this.org_id
    }
    var date = new Date();
    this.model.updated_on = date
    this.accesscontrolService.updateApplication(this.model).subscribe((res) => {
      this.model = res
    }, error => {
      console.log(error)
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastservice.error(errorMessage)
    }, () => {
      this.toastservice.success("Application Updated Successfully");
      this.router.navigate(['/application-listing']);
    })
  }

  information(msg: any) {
    this.toastservice.warning(msg)
  }

  getLogoDetails(e) {
    if (e && e.target && e.target.files[0]) {
      this.logo = (e.target.files[0]);
      this.getBase64(this.logo, (result) => {
          this.model.logo = result;
        },
        function (error) {
          console.log('Error: ', error);
        }
      )

      if (e.target.files[0].size > 300 * 1024) {
        this.isLogoSizeError = true;

      } else {
        this.isLogoSizeError = false;
      }
      var ext = this.logo.name.split('.').pop();
      ext = ext.toLowerCase();
      if (ext === 'jpg' || ext === 'jpeg' || ext === "png" || ext === "bmp" || ext === "tiff") {
        this.isExtensionError = false;
      } else {
        this.isExtensionError = true;
      }
    }
  }

  getBase64(file, success, error) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onerror = error;
    reader.onload = () => {
      success(reader.result)
    };
  }

  getOrganizationApplicationDetails() {
    this.isLoading = true
    const orgId = localStorage.getItem('user_id')
    this.accesscontrolService.getOrganizationApplicationSetting(this.id, orgId).subscribe(
      (response: any) => {
        if (!response.error) this.model = response.data
        this.isLoading = false
      },
      (error) => {
        this.isLoading = false
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.toastservice.error(errorMessage)
      }
    )
  }

}
